import React from 'react';
import { Menu } from 'lucide-react';

import { Button } from '~/shadcn/components/ui/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger,
    DropdownMenuTrigger,
} from '~/shadcn/components/ui/DropdownMenu';

export function PurchaseOrderActionsMenu({
    isSendToVendorDisabled = false,
    lastSentAt,
    onCancel = () => {},
    onDownloadCsv = () => {},
    onDownloadPdf = () => {},
    onDownloadShipList = () => {},
    onDuplicate = () => {},
    onSendToVendor = () => {},
}) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" aria-label="Open actions menu">
                    <Menu className="h-4 w-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuItem onSelect={onDuplicate}>Duplicate</DropdownMenuItem>
                <DropdownMenuSub>
                    <DropdownMenuSubTrigger>Download</DropdownMenuSubTrigger>
                    <DropdownMenuSubContent>
                        <DropdownMenuItem onSelect={onDownloadCsv}>CSV</DropdownMenuItem>
                        <DropdownMenuItem onSelect={onDownloadPdf}>PDF</DropdownMenuItem>
                        <DropdownMenuItem onSelect={onDownloadShipList}>Ship-List</DropdownMenuItem>
                    </DropdownMenuSubContent>
                </DropdownMenuSub>
                <DropdownMenuItem onSelect={onSendToVendor} disabled={isSendToVendorDisabled}>
                    <span>Send to vendor</span>
                    {lastSentAt ? (
                        <span className="text-muted-foreground ml-auto text-xs">Last sent: {lastSentAt}</span>
                    ) : null}
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem variant="destructive" onSelect={onCancel}>
                    Cancel PO
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
